import { COLORS } from '@/styles/colors';
import { resetList } from '@/styles/common';
import { flex } from '@/styles/layout';
import { media } from '@/styles/responsive';
import { bodySmall, caption, poppinsMediumFont } from '@/styles/typography';
import styled from 'styled-components';

export const SidebarDetailsFooterWrapper = styled.div`
  margin-top: auto;
`;

export const SidebarDetailsFooter = styled.div`
  ${flex({ flexDirection: 'row', alignItems: 'center' })};
  padding: 18px 20px;
  margin: 0 auto;

  ${media.mobile`
    padding: 18px 16px;
  `}
`;

export const UserInfo = styled.div`
  ${flex({ flexDirection: 'column', alignItems: 'flex-start' })};
  min-width: 0;
`;

export const UserType = styled.span`
  margin-top: 4px;
  padding: 2px 6px;
  background-color: ${COLORS.grey[850]};
  border-radius: 4px;
  color: ${COLORS.white};
  ${caption};
  ${poppinsMediumFont};

  ${media.mobile`
    ${bodySmall};
  `}
`;

export const LogoutWrapper = styled.ul<{ hasSupportChat?: boolean }>`
  ${resetList};

  ${({ hasSupportChat }) =>
    hasSupportChat &&
    `
      border-bottom: 1px solid ${COLORS.grey[850]};
    `};

  ${media.mobile`
    padding: 20px 16px;
  `}
`;

// export const LogoutLinkWrapper = styled.li`
//   ${flex({ alignItems: 'center' })};
//   padding: 8px 12px;
//   border-radius: 8px;
//   cursor: pointer;

//   &:hover {
//     background-color: ${COLORS.grey[900]};
//   }
// `;

// export const LogoutLink = styled.div`
//   ${poppinsRegularFont};
//   ${bodySmall};
//   color: ${COLORS.grey[600]};
//   margin-left: 12px;

//   ${media.tablet`
//     ${body};
//   `}
// `;

// export const ProfileSectionTitle = styled(MenuSectionTitle)<{ isActive }>`
//   color: ${COLORS.grey[600]};

//   ${({ isActive }) =>
//     isActive &&
//     `
//       color: ${COLORS.white};
//     `};
// `;
